import React from 'react';
import PropTypes from 'prop-types';
import {
  TransitionGroup,
  CSSTransition,
} from 'react-transition-group';
import Alert from './Alert';

const style = {
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 99999999,
};

class AlertContainer extends React.Component {
  render() {
    const alerts = this.props.alerts
      .map(alert => (
        <CSSTransition
          key={alert.id}
          classNames="basic"
          timeout={{ enter: 300, exit: 300 }}
        >
          <Alert
            id={alert.id}
            key={alert.id}
            type={alert.type}
            text={alert.text}
            timeout={alert.timeout}
            {...this.props}
          />
        </CSSTransition>
      ))
      .reverse();

    return (
      <div className="AlertContainer" style={style}>
        <TransitionGroup >
          {alerts}
        </TransitionGroup>
      </div>
    );
  }
}

AlertContainer.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AlertContainer;



// WEBPACK FOOTER //
// ./src/components/shared/AlertContainer.js